'use client';

import { AlertTriangle } from 'lucide-react';
import { useEffect } from 'react';

import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50 p-4 text-center">
      <div className="flex flex-col items-center max-w-md">
        <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-blue-100">
          <AlertTriangle className="h-12 w-12 text-blue-600" />
        </div>

        <h1 className="mb-2 text-4xl font-bold text-blue-800">エラーが発生しました</h1>

        <p className="mb-8 text-lg text-blue-600">
          申し訳ありませんが、予期しないエラーが発生しました。問題が解決しない場合は、サポートまでお問い合わせください。
        </p>

        <div className="flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
          <Button onClick={() => reset()} className="bg-blue-600 hover:bg-blue-700">
            再試行する
          </Button>

          <Button
            variant="outline"
            // エラー境界内のためReact stateが壊れている可能性があり、フルナビゲーションにする
            // eslint-disable-next-line @next/next/no-location-assign-relative-destination
            onClick={() => (window.location.href = '/login')}
            className="border-blue-200 hover:bg-blue-50 hover:text-blue-700"
          >
            ログイン画面に戻る
          </Button>
        </div>

        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8 max-w-full overflow-auto rounded-md bg-slate-900 p-4 text-left text-sm text-slate-50">
            <p className="font-mono">{error.message}</p>
            {error.stack && <pre className="mt-2 text-xs text-slate-300">{error.stack}</pre>}
          </div>
        )}
      </div>
    </div>
  );
}
